(() => {
  const japaneseWeekdays = '日月火水木金土';
  const tokyoDate = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Asia/Tokyo', year: 'numeric', month: 'numeric', day: 'numeric'
  });

  function calculateSchedule(now) {
    const parts = Object.fromEntries(tokyoDate.formatToParts(now).map(({ type, value }) => [type, value]));
    // UTC is used only for arithmetic on the calendar date extracted in Tokyo.
    const cutoff = new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day));
    cutoff.setUTCDate(cutoff.getUTCDate() + (3 - cutoff.getUTCDay() + 7) % 7);
    const shipping = new Date(cutoff);
    shipping.setUTCDate(shipping.getUTCDate() + 8);
    return { cutoff, shipping };
  }

  const japaneseDate = date => `${date.getUTCMonth() + 1}/${date.getUTCDate()}（${japaneseWeekdays[date.getUTCDay()]}）`;

  if (customElements.get('coffee-shipping-schedule')) return;
  customElements.define('coffee-shipping-schedule', class extends HTMLElement {
    connectedCallback() {
      this.update = () => {
        const { cutoff, shipping } = calculateSchedule(new Date());
        const key = shipping.toISOString().slice(0, 10);
        if (this.dataset.shipping === key) return;
        const description = this.querySelector('.coffee-shipping-schedule__description');
        if (!description) return;
        const cutoffText = document.createElement('span');
        cutoffText.textContent = japaneseDate(cutoff);
        const shippingText = document.createElement('time');
        shippingText.dateTime = key;
        shippingText.textContent = japaneseDate(shipping);
        cutoffText.append('までのご注文');
        const shippingGroup = document.createElement('span');
        const separator = document.createElement('span');
        separator.className = 'coffee-shipping-schedule__separator';
        separator.textContent = '→ ';
        shippingGroup.append(separator, shippingText, '焙煎・発送予定');
        description.replaceChildren(cutoffText, shippingGroup);
        this.dataset.shipping = key;
        this.hidden = false;
      };
      // Also refresh an open page exactly at the next Tokyo midnight.
      this.refresh = () => {
        this.update();
        const day = 86400000;
        this.timer = setTimeout(this.refresh, day - ((Date.now() + 9 * 3600000) % day) + 50);
      };
      this.refresh();
      document.addEventListener('visibilitychange', this.update);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.update);
    }
  });
})();
